import { ReportHandler, getCLS, getFID, getFCP, getLCP, getTTFB } from "web-vitals";

export const webVitalsReporter = {
    getCLS,
    getFID,
    getFCP,
    getLCP,
    getTTFB,
};

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
    if (onPerfEntry && typeof onPerfEntry === "function") {
        webVitalsReporter.getCLS(onPerfEntry);
        webVitalsReporter.getFID(onPerfEntry);
        webVitalsReporter.getFCP(onPerfEntry);
        webVitalsReporter.getLCP(onPerfEntry);
        webVitalsReporter.getTTFB(onPerfEntry);
    }
};

export default reportWebVitals;
